import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from './confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private readonly dialog = inject(MatDialog);

  // True only for the confirm button. Cancel, Esc and a backdrop click all
  // resolve false.
  public async confirm(data: ConfirmDialogData): Promise<boolean> {
    const dialogRef = this.dialog.open<
      ConfirmDialogComponent,
      ConfirmDialogData,
      boolean
    >(ConfirmDialogComponent, { data, width: '440px', maxWidth: '90vw' });
    return (await firstValueFrom(dialogRef.afterClosed())) === true;
  }

  // One-button notice; resolves however it's closed.
  public async notify(data: Omit<ConfirmDialogData, 'cancelLabel'>) {
    await this.confirm({ ...data, cancelLabel: null });
  }
}
